import { AType } from "@silversea-ssc/functional-support"
import { ValidateCheckoutErrorCode } from "./error-code"
import { GenericErrorResponse } from "../generic-error-response"
import { ValidateCheckoutRequest } from "./request"

export const ValidateCheckoutErrorResponse = GenericErrorResponse(
    ValidateCheckoutRequest,
    ValidateCheckoutErrorCode,
    "ValidateCheckoutErrorResponse",
)
export type ValidateCheckoutErrorResponse = AType<typeof ValidateCheckoutErrorResponse>
